import React from "react";
import { Divider, Space, Typography } from "antd";

const { Title } = Typography;

export function AdminPublicHeader() {
  return (
    <React.Fragment>
      <div
        style={{
          padding: "16px",
          backgroundColor: "#fef3cd",
          borderColor: "#fadb14",
          textAlign: "center",
        }}
      >
        <Title level={4} style={{ margin: 0, fontWeight: "bold" }}>
          UpResume Admin Panel
        </Title>
      </div>
      <Divider style={{ margin: 0 }} />
    </React.Fragment>
  );
}
